import { type ComponentProps, Suspense, lazy } from 'react';
import { ReadinessGateHold } from 'Shared/react-mount-tracker';
import initializeComponent from 'Shared/react-initialize';

// Only the answers question page places one today. The modal's code (its
// dialog among it) is fetched when a placeholder mounts, so the other pages
// that load this file never download it. The time delay and the scroll check
// start once the code is in.
const loadModals = () => import('@ifixit/ui/newsletter-modal/index');
const TimeDelay = lazy(async () => {
   const { TimeDelayNewsletterModal } = await loadModals();
   return { default: TimeDelayNewsletterModal };
});
const ScrollPercentage = lazy(async () => {
   const { ScrollPercentageNewsletterModal } = await loadModals();
   return { default: ScrollPercentageNewsletterModal };
});

function TimeDelayNewsletterModal(props: ComponentProps<typeof TimeDelay>) {
   return (
      <Suspense fallback={<ReadinessGateHold />}>
         <TimeDelay {...props} />
      </Suspense>
   );
}

function ScrollPercentageNewsletterModal(props: ComponentProps<typeof ScrollPercentage>) {
   return (
      <Suspense fallback={<ReadinessGateHold />}>
         <ScrollPercentage {...props} />
      </Suspense>
   );
}

initializeComponent('TimeDelayNewsletterModalComponent', TimeDelayNewsletterModal);

initializeComponent('ScrollPercentageNewsletterModal', ScrollPercentageNewsletterModal);
